import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { BehaviorSubject, distinctUntilChanged, map, Observable } from 'rxjs';

import { AppContextService } from './app-context.service';
import { AuthSessionService } from './auth-session.service';
import { AccessProfileEnum } from '../enums/access-profile.enum';

@Injectable({
  providedIn: 'root'
})
export class AccessProfileService {
  readonly features$: Observable<string[]>;
  readonly hasMyWorldFeature$: Observable<boolean>;
  readonly #isManager = new BehaviorSubject<boolean>(false);
  readonly isManager$ = this.#isManager.asObservable();

  constructor(
    private readonly authSession: AuthSessionService,
    private readonly appCtx: AppContextService
  ) {
    // Inicializa as propriedades que dependem dos serviços injetados
    this.features$ = this.authSession.user$.pipe(
      map((user) => user?.features ?? [])
    );
    this.hasMyWorldFeature$ = this.features$.pipe(
      map((features) => features.includes('my-world'))
    );

    // Atualiza o estado de isManager com base no profile emitido pelo appCtx
    this.appCtx.profile$
      .pipe(takeUntilDestroyed(), distinctUntilChanged())
      .subscribe((profile) => {
        this.#isManager.next(this.#hasManagerProfile(profile));
      });
  }

  get isManager(): boolean {
    return this.#isManager.getValue();
  }

  #hasManagerProfile(profile: AccessProfileEnum): boolean {
    const profiles = [
      AccessProfileEnum.it,
      AccessProfileEnum.administrator,
      AccessProfileEnum.adviser,
      AccessProfileEnum.schoolMaster,
      AccessProfileEnum.coordinator
    ];

    return profiles.includes(profile);
  }
}
